module.exports = __webpack_public_path__ + "static/media/woman_01.d8973f0b.png";